export default {
  name: 'App',
  data: function () {
    return {};
  }
};